import { VehicleService } from './../../vehicle/models/vehicle.service';
import { DriverModel } from './../../driver/models/driver.model';
import { DriverService } from './../../driver/models/driver.service';
import { SharedVehicleGroupService } from './../models/sharedvehiclegroup.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PersonModel } from '../../person/models/person.model';
import { SharedVehicleGroupModel } from '../../sharedvehiclegroup/models/sharedvehiclegroup.model';
import { PersonService } from '../../person/models/person.service';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, IKeyValueInterface, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';

import { Location } from '@angular/common';

@Component({
  selector: 'wego-svgdriver-list',
  template: require('../views/svgdriver-list.component.html'),
  providers: [SharedVehicleGroupService, DriverService, VehicleService],
})
export class SVGDriverComponent implements OnInit {
  DataListModel: DataListModel;
  driverList: DriverModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  message: string;
  isParentCheck: boolean;
  apiResponse: IAPIResponse;
  urlDefaultPage: string;
  errorMessage: string;
  errorModel: IKeyValueInterface[];
  urlSVGList: string;
  groupName: string;
  sharedVehicleGroupHashId: string = "";

  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;

  get isAnyChecked(): boolean {
    if (this.driverList) {
      let isCheck = this.driverList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.driverList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  constructor(private sharedVehicleService: SharedVehicleGroupService,
    private driverService: DriverService,
    private vehicleService: VehicleService
    , private activeRoute: ActivatedRoute
    , private router: Router
    , private authService: AuthService
    , private translate: TranslateService,
    private locationService: Location) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblDriver')
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlSVGList = this.authService.GetURL(ApplicationRouteURL.URL_SVG_LIST);
    this.activeRoute
      .params
      .subscribe(params => {
        let sharedVehicleGroupHashId = params['sharedVehicleGroupHashId'] || '';
        if (sharedVehicleGroupHashId != '') {
          this.sharedVehicleGroupHashId = sharedVehicleGroupHashId;
          this.GetGroupDriverList();
          this.GetSharedVehicleGropuDetailsByHashId();
        }
      });
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.vehicleService.ExportSVGDriverList(null, this.sharedVehicleGroupHashId, this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "SharedVehicleGroupDrivers" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });;
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetGroupDriverList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetGroupDriverList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetGroupDriverList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetGroupDriverList();
  }

  public OnParentCheck(isChecked: boolean) {
    this.driverList.forEach(x => x.isChecked = isChecked);
  }


  public GetGroupDriverList() {
    this.isLoading = true;
    this.sharedVehicleService.GetSVGDriverList(this.sharedVehicleGroupHashId,"","", this.DataListModel)
      .subscribe(
      res => {
        this.driverList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public GetSharedVehicleGropuDetailsByHashId() {
    this.sharedVehicleService.GetSharedVehicleGroupBasicDetail(this.sharedVehicleGroupHashId)
      .subscribe(
      res => {
        this.groupName = res.data.entityName;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sharedvehiclegroup/components/svgdriver-list.component.ts